import { render, staticRenderFns } from "./CertifyIncome.vue?vue&type=template&id=99383d08&"
import script from "./CertifyIncome.vue?vue&type=script&lang=js&"
export * from "./CertifyIncome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports